module.exports = __webpack_public_path__ + "static/media/ic_nosound.670b13e7.png";